import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_all_emergency_exits_accessible_unobstructed_and_unlocked_du'

export const dataPointDefinition = {
  retracedId: 'are_all_emergency_exits_accessible_unobstructed_and_unlocked_du',
  name: 'Are all emergency exits accessible, unobstructed and unlocked during working hours (including overtime) and lead to a place of safety?',
  description:
    'The intent is to determine if (a) emergency exits can always (during all working hours) be opened, meaning they are not obstructed and they can always be opened by workers from the inside, and (b) exit routes are clear for safe egress. Unlocked emergency exits can mean doors that are fitted with latch guards, security bars, security hinges, or door hinge protectors, as long as workers can open the exit door easily from the inside. \r\r\n\r\r\nAnswer No if emergency exits and escape routes contain any materials, products, equipment, furniture, etc., or if exits cannot always be opened while workers are working.',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'hs-22-4x',
      version: '1.4.0',
      provider: 'slcp',
    },
  ],
  sortingId: 14840,
  sectionId: '2.2.9.4',
  impactArea: 'Emergency Preparedness',
  impactAreaId: 'EMERGENCY_PREPAREDNESS',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
